export class InlineSVGConfig {
  baseUrl = '/assets/svg/';
  bypassHttpClientInterceptorChain?: boolean;
}
